module.exports = __webpack_public_path__ + "static/media/rodoil.707e9c8b.png";